module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai691-7f53cab7315166be7e07c9d22c68d18a.jpg";